import { PulseStorageOptions, isLocalStorageSupported } from '@pulse/common';
import { PulseEnvironment } from '../../globals';
import { Quote } from './quote';
import { PulseSyncStorage } from './sync-storage';
import { TransientStorage } from './transient-storage.backend';

export class PersistentStorage extends PulseSyncStorage {
    constructor(
        env: PulseEnvironment,
        config: PulseStorageOptions,
        quote: Quote,
        transientStorage: TransientStorage,
    ) {
        const storage = (
            isLocalStorageSupported(env.win) ? env.win.localStorage : transientStorage
        ) as Storage;
        super(env, storage, quote, config);
    }
}
